const POST_LOGIN_REDIRECT_KEY = "quest:postLoginRedirect";

export const isSafeQuestRedirect = (path) => {
  if (typeof path !== "string" || !path.startsWith("/quest")) return false;
  if (path.startsWith("//") || path.includes("://")) return false;
  return true;
};

export const rememberPostLoginRedirect = (path) => {
  if (!isSafeQuestRedirect(path)) return;
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  } catch (_) {
    // Ignore quota / private-mode failures.
  }
};

export const peekPostLoginRedirect = () => {
  try {
    return sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  } catch (_) {
    return null;
  }
};

export const consumePostLoginRedirect = (fallback = "/quest") => {
  try {
    const saved = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    if (isSafeQuestRedirect(saved)) return saved;
  } catch (_) {
    // Ignore quota / private-mode failures.
  }
  return fallback;
};
